import { useState } from "react";
import Sidebar from "../layout/Sidebar";
import Loader from "../common/Loader";
import useTourCatalog from "../../hooks/useTourCatalog";
import TourCard from "./TourCard";
import TourModal from "./TourModal";

export default function TourListingPage({
  endpoint = "tours",
  myToursOnly = false,
  title,
  description,
  icon = "fa-plane-departure",
  emptyTitle = "No Tour Results",
  emptyMessage = "No tours are available at the moment.",
  sort = true,
  badgeVisibility= "true"
}) {
  const { tours, loading, error } = useTourCatalog({
    endpoint,
    myToursOnly,
    sort,
  });

  const [selectedTour, setSelectedTour] = useState(null);

  const openTour = (tour) => {
  const isCompleted =
    tour?.access?.status === "completed" ||
    tour?.access?.booking?.isCompleted === true;

  if (isCompleted) return;

  setSelectedTour(tour);
};

  return (
    <>
      <Loader
        isOpen={loading}
        title="Loading Tours"
        heading="Please Wait"
        message="We are loading all tour plans."
      />

      <div className="bgdashboard"></div>
      <Sidebar />

      <div className="dashboardMain sidebarPadding mainPanel">
        <div className="mainPanelIN">
          <div className="relative">
            <section className="documentsBanner">
              <div className="documentsBannerIcon">
                <div className="documentIcon">
                  <i className={`fa-solid ${icon}`}></i>
                </div>
              </div>

              <div className="documentsBannerContent">
                <h3>{title}</h3>
                <p>{description}</p>
              </div>

              <div className="documentsSkyline">
                <span className="skylineBuilding building1"></span>
                <span className="skylineBuilding building2"></span>
                <span className="skylineBuilding building3"></span>
                <span className="skylineBuilding building4"></span>
                <span className="skylineTower tower1"></span>
                <span className="skylineTower tower2"></span>
                <span className="skylineTower tower3"></span>
                <div className="travelBridge"></div>
                <i className="fa-solid fa-plane skylinePlane"></i>
              </div>
            </section>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <div className="row matchHeight">
              {tours.length > 0 ? (
                tours.map((tour) => (
                  <TourCard
                    key={`${tour.id}-${tour.application_id || "tour"}`}
                    tour={tour}
                    onOpen={openTour}
                    badgeVisibility={badgeVisibility}
                  />
                ))
              ) : !loading ? (
                <div className="col-12">
                  <div className="noTours w-100">
                    <div className="noToursIcon">
                      <i className="fa-solid fa-plane"></i>
                    </div>
                    <h4>{emptyTitle}</h4>
                    <p>{emptyMessage}</p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <TourModal
        modalIsOpen={
          Boolean(selectedTour) &&
          selectedTour?.access?.status !== "completed" &&
          selectedTour?.access?.booking?.isCompleted !== true
        }
          closeModal={() => setSelectedTour(null)}
          tour={selectedTour}
        />
    </>
  );
}
